import React,  {useState, useMemo, useCallback, useContext} from 'react'
import {
    clsx,
    styled,
    Box,
    Fade,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from 'external/material'

import {subSeconds} from 'external/date-fns'

import useIntervalCallback from 'hooks/interval-callback'

import {TeacherContext} from 'teacher/context'

import {createLogoutHandler, keepAlive} from 'helpers/users'

import Timer from 'components/Timer'

const StyledDialog = styled(Dialog)(dialogStyles)

const id = 'keep-alive-form'

const keepAliveLeeway = 60

export default function KeepAliveForm () {

  const {translate, refreshProfile, profile, languageId} = useContext(TeacherContext)
  const {institution: {project}, expiration} = profile || {institution: {}, expiration: 0}

  const [open, setOpen] = useState(false)

  const target = useMemo(() => subSeconds(expiration, keepAliveLeeway), [expiration])
  
  useIntervalCallback(()=> {
      setOpen(true)
  }, target)

  const handleLogout = useMemo(() => createLogoutHandler(languageId, project), [project, languageId])

  const handleKeepAlive = useCallback(() => {
      keepAlive().then(async () => {
          await refreshProfile()
          setOpen(false)
      }).catch(handleLogout)
  }, [])

  
  const titleId = `${id}-title`

  return (
    <StyledDialog open={open} aria-labelledby={titleId} disableEscapeKeyDown>
      <DialogTitle id={titleId} className="title-container">
          <Box className="title">{translate(`${id}-title`)}</Box>
      </DialogTitle>
      <DialogContent className="content-container">
        <Box className="content">{translate(`${id}-message`, {project: translate(`${project}_project_title`)})}</Box>
      </DialogContent>
      <Fade in={true}>
          <DialogActions className="actions-container">
            <Box className="actions">
                <Button variant="contained" color="background" className={clsx('button', 'keep-alive')} onClick={handleKeepAlive}>
                    {translate(`${id}-keep-alive`)}
                </Button>
                <Button variant="contained" color="error" className={clsx('button', "logout")} onClick={handleLogout}>
                  <span className="label">{translate(`${id}-logout`)}</span>
                  <Timer className="logout-timer" startWrapper="(" endWrapper=")" startsAt={expiration} onExpiration={handleLogout} format={i => i} />
                </Button>
            </Box>
          </DialogActions>
      </Fade>
    </StyledDialog>
  )
}

function dialogStyles() {

  return {
    display: 'flex',
    justifyContent: 'center',
    "& .MuiPaper-root": {
      maxWidth: 600
    },
    "& .title-container": {
      display: 'flex',
      justifyContent: 'center'
    },
    "& .content-container": {
      display: 'flex',
      padding: '0px 15px 15px 15px',
      justifyContent: 'center',
      "& .content": {
        maxWidth: 400,
        textAlign: 'justify'
      }
    },
    "& .actions-container": {
      display: 'flex',
      padding: '0px 15px 15px 15px',
      '& .actions': {
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'flex-end',
       '& .button': {
          width: 100,
          display: 'flex',
         "& .label": {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
         },
        "&.logout": {
          marginLeft: 20
        },
        "& .logout-timer": {
           marginLeft: 5,
           display: "flex"          
         }
        }
      }
    }
  }
}